import { createReducer } from '@reduxjs/toolkit';
import {
  getMentoringProgramReflectionSummary,
  getMentoringProgramReflectionQuestions,
  getMentoringProgramReflectionResponses,
  submitMentoringProgramReflectionResponses,
} from 'redux/actions/mentoring-program-reflections';
import { defaultMentoringProgramReflectionSummary } from 'redux/schemas/models/mentoring-program-reflections';
import { initialRootState } from '.';

export default createReducer(initialRootState, (builder) => {
  builder
    .addCase(getMentoringProgramReflectionSummary.pending, (state, action) => {
      const { connectionId } = action.meta.arg;
      const existing = state.app.mentoringProgram.reflections[connectionId];
      state.app.mentoringProgram.reflections[connectionId] = {
        ...existing,
        isLoading: true,
        summary:
          existing?.summary ?? defaultMentoringProgramReflectionSummary,
      };
    })
    .addCase(
      getMentoringProgramReflectionSummary.fulfilled,
      (state, action) => {
        const { connectionId } = action.meta.arg;
        const existing = state.app.mentoringProgram.reflections[connectionId];
        state.app.mentoringProgram.reflections[connectionId] = {
          ...existing,
          isLoading: false,
          summary: action.payload,
        };
      }
    )
    .addCase(getMentoringProgramReflectionSummary.rejected, (state, action) => {
      const { connectionId } = action.meta.arg;
      const existing = state.app.mentoringProgram.reflections[connectionId];
      state.app.mentoringProgram.reflections[connectionId] = {
        ...existing,
        isLoading: false,
        summary:
          existing?.summary ?? defaultMentoringProgramReflectionSummary,
      };
    })
    .addCase(getMentoringProgramReflectionQuestions.pending, (state, action) => {
      const { connectionId } = action.meta.arg;
      const existing = state.app.mentoringProgram.reflections[connectionId];
      state.app.mentoringProgram.reflections[connectionId] = {
        ...existing,
        isLoading: existing?.isLoading ?? false,
        summary: existing?.summary ?? defaultMentoringProgramReflectionSummary,
        questions: existing?.questions ?? [],
      };
    })
    .addCase(getMentoringProgramReflectionQuestions.fulfilled, (state, action) => {
      const { connectionId } = action.meta.arg;
      const existing = state.app.mentoringProgram.reflections[connectionId];
      state.app.mentoringProgram.reflections[connectionId] = {
        ...existing,
        isLoading: existing?.isLoading ?? false,
        summary: existing?.summary ?? defaultMentoringProgramReflectionSummary,
        questions: action.payload,
      };
    })
    .addCase(getMentoringProgramReflectionQuestions.rejected, (state, action) => {
      const { connectionId } = action.meta.arg;
      const existing = state.app.mentoringProgram.reflections[connectionId];
      state.app.mentoringProgram.reflections[connectionId] = {
        ...existing,
        isLoading: existing?.isLoading ?? false,
        summary: existing?.summary ?? defaultMentoringProgramReflectionSummary,
        questions: existing?.questions ?? [],
      };
    })
    .addCase(getMentoringProgramReflectionResponses.pending, (state, action) => {
      const { connectionId } = action.meta.arg;
      const existing = state.app.mentoringProgram.reflections[connectionId];
      state.app.mentoringProgram.reflections[connectionId] = {
        ...existing,
        isLoading: existing?.isLoading ?? false,
        summary: existing?.summary ?? defaultMentoringProgramReflectionSummary,
        participantResponses: { isLoading: true, data: existing?.participantResponses?.data ?? null },
      };
    })
    .addCase(getMentoringProgramReflectionResponses.fulfilled, (state, action) => {
      const { connectionId } = action.meta.arg;
      const existing = state.app.mentoringProgram.reflections[connectionId];
      state.app.mentoringProgram.reflections[connectionId] = {
        ...existing,
        isLoading: existing?.isLoading ?? false,
        summary: existing?.summary ?? defaultMentoringProgramReflectionSummary,
        participantResponses: { isLoading: false, data: action.payload },
      };
    })
    .addCase(getMentoringProgramReflectionResponses.rejected, (state, action) => {
      const { connectionId } = action.meta.arg;
      const existing = state.app.mentoringProgram.reflections[connectionId];
      state.app.mentoringProgram.reflections[connectionId] = {
        ...existing,
        isLoading: existing?.isLoading ?? false,
        summary: existing?.summary ?? defaultMentoringProgramReflectionSummary,
        participantResponses: { isLoading: false, data: existing?.participantResponses?.data ?? null },
      };
    })
    .addCase(submitMentoringProgramReflectionResponses.pending, (state, action) => {
      const { connectionId } = action.meta.arg;
      const existing = state.app.mentoringProgram.reflections[connectionId];
      state.app.mentoringProgram.reflections[connectionId] = {
        ...existing,
        isLoading: existing?.isLoading ?? false,
        summary: existing?.summary ?? defaultMentoringProgramReflectionSummary,
        isSubmitting: true,
      };
    })
    .addCase(submitMentoringProgramReflectionResponses.fulfilled, (state, action) => {
      const { connectionId } = action.meta.arg;
      const existing = state.app.mentoringProgram.reflections[connectionId];
      state.app.mentoringProgram.reflections[connectionId] = {
        ...existing,
        isLoading: existing?.isLoading ?? false,
        summary: existing?.summary ?? defaultMentoringProgramReflectionSummary,
        isSubmitting: false,
      };
    })
    .addCase(submitMentoringProgramReflectionResponses.rejected, (state, action) => {
      const { connectionId } = action.meta.arg;
      const existing = state.app.mentoringProgram.reflections[connectionId];
      state.app.mentoringProgram.reflections[connectionId] = {
        ...existing,
        isLoading: existing?.isLoading ?? false,
        summary: existing?.summary ?? defaultMentoringProgramReflectionSummary,
        isSubmitting: false,
      };
    });
});
